module.exports = __webpack_public_path__ + "img/Bug Icon - white.f046d559.svg";